import {
    POST,
    GET
} from "../util";
const receivablesUrl = "api/seller-all-receivables-inspection/";
import APP from "../appConfig";

const url = {
    list: `${receivablesUrl}list`,
    // details?receivableId={receivableId}&auctionId={auctionId}
    details: `${receivablesUrl}details`,
    downloadAllDocuments: `${receivablesUrl}download-all-documents`,
    // export-csv/{fromDate}/{toDate}date format: dd-MM-yyyy
    exportCsv: `${receivablesUrl}export-csv`,


};
const allReceivablesApi = {
    list: (params = {}) => {
        return POST(url.list, params);
    },
    details: (params = {}) => {
        return GET(url.details, params);
    },
    downloadAllDocuments: (params = {}) => {
        return POST(url.downloadAllDocuments, params);
    },
    exportCsv: (params = {}) => {
        return GET(url.exportCsv + '/' + params.fromDate + '/' + params.toDate);
    },
    exportCsvUrl: (params = {}) => {
        return APP.DOMAIN + url.exportCsv + '/' + params.fromDate + '/' + params.toDate;
        // return GET(url.exportCsv + '/' + params.fromDate + '/' + params.toDate);
    },
};
export {
    allReceivablesApi
};